import { EditorState, generateName } from "@common/Common";

export class RevenueEditorViewModel
{
    state: EditorState = EditorState.Closed;
    title: string | null = null;
    confirmButtonLabel: string | null = null;

    id: string | null = null;
    name: string | null = null;
    description: string | null = null; 
    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator()
    {
        this.id = null;
        this.name = generateName("Revenue");
        this.description = null;

        this.title = 'Create revenue stream';
        this.confirmButtonLabel = "Create";
        this.state = EditorState.Creator;
    }

    showEditor(id: string, name: string, description: string | null)
    {
        this.id = id;
        this.name = name;
        this.description = description;

        this.title = 'Edit revenue stream';
        this.confirmButtonLabel = "Update";
        this.state = EditorState.Editor;
    }

    close()
    {
        this.id = null;
        this.name = null;
        this.description = null;

        this.title = null;
        this.confirmButtonLabel = null;

        this.state = EditorState.Closed;
    }
}

export class RevenueEditorFormSubmitEventPayload
{
    id: string | null;
    name: string;
    description: string | null;

    constructor(id: string | null, name: string, description: string | null)
    {
        this.id = id;
        this.name = name;
        this.description = description;
    }
}